import { render, staticRenderFns } from "./ScanInfoDetails.vue?vue&type=template&id=40a0542f&scoped=true"
import script from "./ScanInfoDetails.vue?vue&type=script&lang=js"
export * from "./ScanInfoDetails.vue?vue&type=script&lang=js"
import style0 from "./ScanInfoDetails.vue?vue&type=style&index=0&id=40a0542f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a0542f",
  null
  
)

export default component.exports